import { shallowMount } from "@vue/test-utils";
import OfertaCuenta from "@/views/OfertaCuenta";
import bus from "@/bus";

describe("OfertaCuenta component", () => {
  let wrapper;

  beforeEach(() => {
    jest.clearAllMocks();
    wrapper = shallowMount(OfertaCuenta);
    wrapper.vm.$router.push.mockClear();
  });

  it("Renders del component OfertaCuenta", () => {
    expect(wrapper).toBeDefined();
  });

  it("continuar emite analytics:event y navega al siguiente paso", () => {
    const emitSpy = jest.spyOn(bus, "$emit");
    wrapper.vm.config.pasos.ofertaCuenta.pasoSiguiente = "siguientePaso";

    wrapper.vm.continuar();

    expect(emitSpy).toHaveBeenCalledWith("analytics:event", {
      event: "interaction_link",
      eventData: {
        name: "abri tu cuenta en BBVA",
        level2: "oferta",
        level3: "ca"
      }
    });
    expect(wrapper.vm.$router.push).toHaveBeenCalledWith("siguientePaso");
  });
});
